export default{
  getModels:state=>markId=>{
    var ind= state.carModels.findIndex(x=>x.markId==markId)
    if(ind!=-1&&ind!=undefined){
      return state.carModels[ind].data;
    }
    else return null;
  },

  getYears:state=>modelId=>{
    var ind= state.years.findIndex(x=>x.modelId==modelId)
    if(ind!=-1&&ind!=undefined){
      return state.years[ind].data;
    }
    else return null;
  }
}
